import {createAction} from '@ngrx/store';

export const selectedTranslationChanged = createAction(`Selected Translation Changed`);
